<template>
  <v-app>
    <app-drawer></app-drawer>
    <app-bar></app-bar>
    <v-main>
      <v-container>
        <div v-if="isLoading()">
          <v-progress-linear indeterminate></v-progress-linear>
        </div>
        <router-view :key="$route.path"></router-view>
      </v-container>
    </v-main>
    <app-footer></app-footer>
    <bottom-nav></bottom-nav>
  </v-app>
</template>

<script>
import appDrawer from "@/components/app/drawer";
import appBar from "@/components/app/appbar";
import appFooter from "@/components/app/footer";
import bottomNav from "@/components/app/bottom";

export default {
  components: {
    "app-bar": appBar,
    "app-drawer": appDrawer,
    "app-footer": appFooter,
    "bottom-nav": bottomNav,
  },

  methods: {
    isLoading() {
      return this.$store.getters.getLoading;
    },
  },
};
</script>

<style>
</style>